import {
  Avatar,
  Box,
  Button,
  Divider,
  Stack,
  Typography,
  styled
} from "@mui/material";

export const ActionButton = styled(Button)(({ theme }) => ({
  color: theme.customColors.systemSecondary01,
  fontSize: "16px",
  fontWeight: "500",
  justifyContent: "flex-start",
  padding: "0",
  textTransform: "none",

  "&:hover": {
    background: "none"
  }
}));

export const NameTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "16px",
  fontWeight: "700",
  lineHeight: "21px",

  [theme.breakpoints.down("sm")]:{
    fontSize: "14px"
  }
}));

export const CommentTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.exploreCardText,
  fontSize: "16px",
  fontWeight: "400",
  lineHeight: "21px",

  [theme.breakpoints.down("sm")]:{
    fontSize: "14px"
  }
}));

export const AuthorTypography = styled(Typography)(({ theme }) => ({
  color: `${theme.customColors.textTag} !important`,
  fontSize: "0.75rem"
}));

export const CommentOuterStack = styled(Stack)(({ theme }) => ({
  paddingTop: "16px",
  width: "100%",
  [theme.breakpoints.down("sm")]: {
    gap: "8px"
  }
}));

export const CommentVerticalDivider = styled(Divider)(({ theme }) => ({
  borderColor: theme.customColors.border,
  flexGrow: "1",
  margin: "0 20px"
}));

export const CommentInputWrapper = styled(Box)(() => ({
  borderRadius: "8px",
  flexGrow: 1,
  overflow: "hidden"
}));

export const CommentAuthorAvatar = styled(Avatar)(({ theme }) => ({
  color: theme.customColors.headerIcon,
  width: "40px",
  height: "40px"
}));

export const LoadMoreButton = styled(Button)(() => ({
  gap: "0.5rem",
  margin: "0 auto",
  width: "fit-content"
}));
